import type { SchemaChatResolver_GetChats } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { NUMBER_SWITCH_TARGET_KINDS } from '~/features/whatsapp/constants/numberSwitchTarget';
import { useNumberSwitchAction } from '~/features/whatsapp/hooks/useNumberSwitchAction';

type Props = {
    chat: SchemaChatResolver_GetChats[number];
};

export const ChatNumberSwitchButton = ({ chat }: Props) => {
    const { t } = useTranslation();
    const { canSwitch, isPending, switchChat, targetKind } = useNumberSwitchAction(chat);

    if (!canSwitch) return null;

    return (
        <button
            type="button"
            className="shrink-0 font-semibold underline disabled:opacity-50"
            disabled={isPending}
            onClick={switchChat}
        >
            {targetKind === NUMBER_SWITCH_TARGET_KINDS.OPEN_CHAT
                ? t('WHATSAPP_CHAT.NUMBER_STATUS.OPEN_CURRENT_CHAT')
                : t('WHATSAPP_CHAT.NUMBER_STATUS.START_CURRENT_CHAT')}
        </button>
    );
};
